import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const AfterGraduation = () => {
  const [groupedCourses, setGroupedCourses] = useState({});

  useEffect(() => {
    const fetchCourseList = async () => {
      try {
        const response = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/fetchAfterGraduationCourseList`
        );

        const courses = response.data.data;

        // Group by school_name
        const grouped = courses.reduce((acc, course) => {
          const school = course.school_name || "Other Schools";
          if (!acc[school]) {
            acc[school] = [];
          }
          acc[school].push(course);
          return acc;
        }, {});

        setGroupedCourses(grouped);
      } catch (error) {
        console.error("Error fetching courseList:", error);
      }
    };

    fetchCourseList();
  }, []);

  const formatSchoolName = (str) => {
    return str
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
     <React.Fragment>
      <div className="row">
        {Object.entries(groupedCourses).map(([schoolName, courses]) => (
          <div key={schoolName} className="mb-4 col-12 p-4 rounded shadow">
            <h5 className="fw-bold text-school text-decoration-underline mb-4">
              {formatSchoolName(schoolName)}
            </h5>
            <ul className="list-unstyled row">
              {courses.map((course) => (
                <li key={course.id} className="col-lg-4 col-md-4">
                  <Link to={`/course-details/${course.name}`} target="_blank">
                    {course.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default AfterGraduation;
